// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Document_wrapper__36tLx","title":"Document_title__2QJGj"};